import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import IconAdd from '../../components/icons/IconAdd';
import IconBuild from '../../components/icons/IconBuild';
import CourseSearchSelect from '../students/CourseSearchSelect';
import language from '../../variables/language';
import '../../css/student-card.css';

// Group-wide mirror of students/StudentCourses.jsx - assigning a course
// here links EVERY current group member to it at once (StudentCourse rows
// tagged with this group's id, server-side) rather than one student at a
// time. Clicking a row opens the new group workspace view (mirrors
// StudentWorkspaceView.jsx, but merges every member's activity into one
// screen) - see groups/workspace/GroupCourseWorkspaceView.jsx.
export default function GroupCourses({ groupId, refresh }) {
   const navigate = useNavigate();
   const lang = language[language.lang];

   const [courses, setCourses] = useState([]);
   const [status, setStatus] = useState('loading');
   const [localRefresh, setLocalRefresh] = useState(0);
   const [pickedCourseId, setPickedCourseId] = useState('');
   const [adding, setAdding] = useState(false);

   const refreshList = () => setLocalRefresh(prev => prev + 1);

   useEffect(() => {
      if (!groupId) return;
      setStatus('loading');
      axios.get('/api/groups/' + groupId + '/courses', { withCredentials: true })
         .then(response => {
            setCourses(Array.isArray(response.data) ? response.data : []);
            setStatus('done');
         })
         .catch(err => {
            if (err.response && err.response.status === 401) navigate('/login');
            setStatus('done');
         });
   }, [groupId, refresh, localRefresh, navigate]);

   const excludeIds = courses.map(c => c.id).filter(Boolean);

   const handleAdd = () => {
      if (!pickedCourseId || adding) return;
      setAdding(true);
      axios.post('/api/groups/' + groupId + '/courses', JSON.stringify({ course: pickedCourseId }), {
         withCredentials: true,
         headers: { 'Content-Type': 'application/json' },
      }).then(() => {
         setPickedCourseId('');
         refreshList();
      }).catch(err => {
         if (err.response && err.response.status === 401) navigate('/login');
         console.log(err);
      }).finally(() => setAdding(false));
   }

   const openWorkspace = (course) => navigate('/groups/' + groupId + '/workspace/' + course.id);
   const openConstructor = (e, course) => {
      e.stopPropagation();
      navigate('/courses/' + course.id, { state: { returnTo: '/groups/' + groupId } });
   }

   return (
      <div className='group-card-section'>
         <h4 className='group-card-section-title'>{lang.groupCard.coursesTitle}</h4>

         <div className='student-lessons-toolbar'>
            <div className='words-tab-add-existing'>
               <CourseSearchSelect value={pickedCourseId} onChange={setPickedCourseId}
                  excludeIds={excludeIds} placeholder={lang.choosePlaceholderCourse} />
               <div className={'student-lessons-add-btn' + (!pickedCourseId || adding ? ' conv-panel-add-btn-disabled' : '')}
                  onClick={handleAdd} title={lang.addLinkCourse}>
                  <IconAdd />
               </div>
            </div>
         </div>

         <div className='group-courses-table-wrap'>
            <table className='student-lessons-table'>
               <thead>
                  <tr>
                     <th>{lang.name}</th>
                     <th></th>
                  </tr>
               </thead>
               <tbody>
                  {status === 'loading' ? (
                     <tr className='group-courses-empty-row'><td colSpan={2}>{lang['Loading ...']}</td></tr>
                  ) : ''}
                  {status === 'done' ? courses.map(course => (
                     <tr key={course.id} className='student-lessons-row' onClick={() => openWorkspace(course)}>
                        <td className='student-lessons-text-cell'>{course.name}</td>
                        <td className='student-lessons-actions-cell' onClick={e => e.stopPropagation()}>
                           <div className='student-lessons-icon-btn' onClick={(e) => openConstructor(e, course)} title='Відкрити в конструкторі'>
                              <IconBuild style={{ fill: '#8fc9c3', width: 14, height: 14, margin: 0 }} />
                           </div>
                        </td>
                     </tr>
                  )) : ''}
                  {status === 'done' && courses.length === 0 ? (
                     <tr className='group-courses-empty-row'><td colSpan={2}>{lang.noCourses}</td></tr>
                  ) : ''}
               </tbody>
            </table>
         </div>
      </div>
   );
}
